module.exports = __webpack_public_path__ + "static/media/argonlogo.b7084501.png";